import {useContext, useEffect} from "react";

import {NotificationsContext} from "@ui-components/Notifications";
import {DataContext} from "../DataContext/DataContext";
import apiRequest from "../apiRequest";

const useTeams = () => {
  const {push} = useContext(NotificationsContext);
  const dataContext = useContext(DataContext);

  useEffect(() => {
    let closed = false;
    const fetchData = async () => {
      try {
        const data = await apiRequest.get(`/teams`);
        if (!closed) {
          dataContext.setTeams(data);
        }
      } catch (error) {
        console.log(error)
        dataContext.setTeams(false);
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

    if (dataContext.teams === null) {
      fetchData();
    }

    return () => {
      closed = true;
    };
  }, [dataContext.teams, push]);  // eslint-disable-line react-hooks/exhaustive-deps

  if (!dataContext.teams) {
    return undefined
  }

  return dataContext.teams;

};

export default useTeams;
